export default __webpack_public_path__ + "cf3252c1647de73b70436da89bdf29d8.png";